import "babel-polyfill";
import vuetify from "./plugins/vuetify"
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import VueAnalytics from "vue-analytics";
import environment from "./env.js";
Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: "UA-144026074-1",
  debug: {
    sendHitTask: environment === "production"
  },
  router
});
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
